import { render, staticRenderFns } from "./meteorological.vue?vue&type=template&id=c68faff2&scoped=true&"
import script from "./meteorological.vue?vue&type=script&lang=js&"
export * from "./meteorological.vue?vue&type=script&lang=js&"
import style0 from "./meteorological.vue?vue&type=style&index=0&id=c68faff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68faff2",
  null
  
)

export default component.exports